import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import posthog from 'posthog-js';
import App from './App.tsx';
import './index.css';

// Initialize PostHog with improved configuration
posthog.init('phc_OkvleHpacRpQYpac0jM1rVKoArDlz2kDbZ54RWTmiSD', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  persistence: 'localStorage',
  autocapture: true,
  capture_pageview: true,
  capture_pageleave: true,
  disable_session_recording: true,
  loaded: (posthog) => {
    // Track Core Web Vitals
    if ('web-vital' in window) {
      // @ts-expect-error window.webVitals.getCLS is not a function
      window.webVitals.getCLS((metric) =>
        posthog.capture('web_vital_cls', { value: metric.value })
      );
      // @ts-expect-error window.webVitals.getFID is not a function
      window.webVitals.getFID((metric) =>
        posthog.capture('web_vital_fid', { value: metric.value })
      );
      // @ts-expect-error window.webVitals.getLCP is not a function
      window.webVitals.getLCP((metric) =>
        posthog.capture('web_vital_lcp', { value: metric.value })
      );
    }
  },
});

// Add error boundary for analytics
window.onerror = function (msg, url, lineNo, columnNo, error) {
  posthog.capture('error', {
    message: msg,
    url: url,
    line: lineNo,
    column: columnNo,
    error: error?.toString(),
  });
  return false;
};

// Create React root with strict mode
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
